module.exports = __webpack_public_path__ + "static/media/image-card-9.d0209853.png";